import { $t } from '@/modules/i18n';

export function transformArray(data) {
  return Array.isArray(data) ? data.map(item => $t(item)).filter(item => !!item) : ($t(data) || '').split('\n').map(str => str.trim()).filter(Boolean)
}

let overflow;
let isInit = false;

export function fixHtmlAndBody() {
  if(!isInit) {
    overflow = document.body.style.overflow || document.documentElement.style.overflow;
    isInit = true;
  }
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
}

export function looseHtmlAndBody() {
  document.body.style.overflow = overflow;
  document.documentElement.style.overflow = overflow;
}

export function isMiniScreen() {
  const ua = window.navigator.userAgent;
  const isIos = ua.indexOf('iPhone') >= 0 || ua.indexOf('iPad') >= 0 || ua.indexOf('iPod') >= 0;
  const isAndroid = ua.indexOf('Android') > 0;
  if (isIos || isAndroid) {
    return true;
  }

  return document.body.clientWidth <= 991; // SCL mobile width
}